export const setAllSessions = (value) => {
  return {
    type: "SET_All_SESSIONS",
    payload: { data: value },
  };
};
export const setSessionsForToday = (value) => {
  return {
    type: "SET_SESSIONS_FOR_TODAY",
    payload: { data: value },
  };
};
export const setCurrentStaffSessionsForToday = (value) => {
  return {
    type: "SET_CURRENT_STAFF_SESSIONS_FOR_TODAY",
    payload: { data: value },
  };
};
export const setCurrentStaffActiveSession = (value) => {
  return {
    type: "SET_CURRENT_STAFF_ACTIVE_SESSION",
    payload: { data: value },
  };
};
export const setCurrentStaffSessionsToVerify = (value) => {
  return {
    type: "SET_CURRENT_STAFF_SESSIONS_TO_VERIFY",
    payload: { data: value },
  };
};
export const setStartStaffSessionModalOpen = (value) => {
  return {
    type: "SET_START_STAFF_SESSION_MODAL_OPEN",
    payload: { data: value },
  };
};
export const setEndStaffSessionModalOpen = (value, sessionId) => {
  return {
    type: "SET_END_STAFF_SESSION_MODAL_OPEN",
    payload: { data: value, sessionId },
  };
};
export const setVerifyAndInfoStaffSessionsModalOpen = (value) => {
  return {
    type: "SET_VERIFY_AND_INFO_STAFF_SESSIONS_MODAL_OPEN",
    payload: { data: value },
  };
};
export const setConfirmCloseStaffSessionModalOpen = (value, openedSession) => {
  return {
    type: "SET_CONFIRM_CLOSE_STAFF_SESSION_MODAL_OPEN",
    payload: { data: value, openedSession },
  };
};